import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
export var getMemberConversation = function getMemberConversation(conversationsStore, memberId) {
  var conversations = Object.values(conversationsStore);
  var userConversations = conversations.filter(function (_ref) {
    var type = _ref.type;
    return type === 'direct';
  }).filter(function (conversation) {
    return conversation.members.find(function (member) {
      return member.id.toLowerCase() === memberId.toLowerCase();
    });
  });
  return userConversations.length ? userConversations[0] : null;
};